<template>
    <div>
        <div class="row">
            <div class="col-12">
                <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">
                    <li v-if="status=='Creado' || status=='Enviado' || req.requiredRevisionCommercial" class="nav-item" role="presentation">
                        <a :class="'nav-link ' + isCreated" id="form-tab" data-toggle="tab" href="#form-create-mix" role="tab" aria-controls="home" aria-selected="true">
                            <i class="fas fa-plus-circle"></i> Creación de muestras
                        </a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a :class="'nav-link ' + isSended" id="list-tab" data-toggle="tab" href="#list-mix" role="tab" aria-controls="profile" aria-selected="false" @click="getComponent">
                            <i class="fas fa-list-alt"></i> Lista de muestras <span class="badge badge-primary">{{ totalMix }}</span>
                        </a>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <div v-if="status=='Creado' || status=='Enviado' || req.requiredRevisionCommercial" :class="'tab-pane fade ' + isCreated + ' ' + isCreatedtoShow" id="form-create-mix" role="tabpanel" aria-labelledby="form-tab">
                        <form-component ref="formMix" :id="requestId" @updateDetails="getDetails" />
                    </div>
                    <div :class="'tab-pane fade ' + isSended + ' ' + isSendedtoShow" id="list-mix" role="tabpanel" aria-labelledby="list-tab">
                        <list-component @updateObservations="updateObservations" @updateComponents="getComponent" :request="req"  :dispatch="dispatch" @copyItem="copyItem($event)" :details="details" :compositions="compositions" :id="requestId" @updateDetails="getDetails" :status="status" />
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
import FormComponent from './Form.vue'
import ListComponent from './List.vue'
import {Get} from '../../../helper/axios.js'
import $ from 'jquery'
export default {
    props: ['requestId', 'dispatch','status',"req"],
    components: {
        FormComponent,
        ListComponent
    },
    data() {
        return {
            details: [],
            compositions: [],
            Get,
            components: [],
            apiUrl: this.$store.getters.apiUrl,
        }
    },
    created() {
        this.getDetails();
        this.getComposition();
        this.getComponent();

    },
    methods: {
        updateObservations(){
            this.getDetails();
        },
        getDetails() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/requestsample/${this.requestId}/details`, (res) => {
                this.details = res.data;
                this.$store.commit("setLoading", false);
                this.getComposition();
            });
        },
        async copyItem(item) {
            await this.$refs.formMix.clone(item);
            $('#form-tab').tab('show');
        },
        getComposition(){
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/compositions/", res => {
                this.compositions = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getComponent() {
            this.$store.commit("setLoading", true);
                this.Get(this.apiUrl+'v1/selectedComponents', (res) => {
                    this.components = res.data
                    this.$store.commit("setLoading", false);
            })
        }
    },
    computed: {
        totalMix() {
            return this.details ? this.details.length : 0;
        },
        isCreated(){
            return this.status=='Creado' ? 'active' : '';
        },
        isSended(){
            return this.status=='Enviado' ? 'active' : '';
        },
        isCreatedtoShow(){
            return this.status=='Creado' ? 'show' : '';
        },
        isSendedtoShow(){
            return this.status=='Enviado' ? 'show' : '';
        }
    }
}
</script>


